import React from "react";
import { Link } from "react-router-dom";
import { inrRange, locationLine } from "@/lib/format";
import { MapPin, Calendar as CalIcon, Speaker } from "lucide-react";
import { TagList } from "./Tag";
import GigStatusBadge from "./GigStatusBadge";

export default function GigCard({ opportunity: op }) {
  return (
    <Link to={`/opportunities/${op.opportunity_id}`} data-testid={`gigcard-${op.opportunity_id}`}
      className="block bg-white border border-slate-200 rounded-xl overflow-hidden hover:shadow-md hover:-translate-y-0.5 transition-all">
      <div className="p-5">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <div className="flex items-center gap-2">
              <div className="text-xs font-semibold uppercase tracking-wider text-[#4F46E5]">
                {op.opportunity_type?.replace(/_/g, " ")}
              </div>
              <GigStatusBadge status={op.status} testId={`gig-status-${op.opportunity_id}`} />
            </div>
            <h3 className="mt-1 font-semibold text-slate-900 truncate">{op.title}</h3>
            <div className="text-xs text-slate-500 mt-1">Posted by {op.poster_name}</div>
          </div>
          <img src={op.poster_picture_url} alt="" className="w-10 h-10 rounded-lg object-cover bg-slate-100 flex-none" />
        </div>
        <p className="mt-3 text-sm text-slate-600 line-clamp-2">{op.description}</p>
        <div className="mt-3 grid grid-cols-2 gap-y-1.5 text-xs text-slate-600">
          <div className="flex items-center gap-1"><MapPin className="w-3.5 h-3.5" />{locationLine(op) || "—"}</div>
          <div className="flex items-center gap-1"><CalIcon className="w-3.5 h-3.5" />{op.date || "Flexible"}</div>
          <div className="flex items-center gap-1 col-span-2">
            <Speaker className="w-3.5 h-3.5" />
            PA system {op.pa_system_provided ? "provided" : "not provided"}
          </div>
        </div>
        <div className="mt-3">
          <TagList items={op.required_talent} max={3} tone="accent" />
        </div>
        <div className="mt-4 pt-3 border-t border-slate-100 text-sm font-semibold text-slate-900">
          {inrRange(op.budget_min, op.budget_max)}
        </div>
      </div>
    </Link>
  );
}
